import React from 'react';
import { Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import moment from 'moment';
import { useDateRangesInputContext } from './DateRangesInput.context';
import { RangeItem } from './RangeItem';
import { AddRangeButton } from './AddRangeButton';
import { HelpCenter } from '@mui/icons-material';

export const RangesList = () => {
  const {
    disabled,
    reply,
    single,
    dateRanges = { default: [] },
    activeDateRange,
    showInstructions,
    setShowInstructions,
  } = useDateRangesInputContext();
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <Grid container spacing={1}>
      {(!reply ||
        (dateRanges?.default?.length > 0 &&
          dateRanges?.default?.[0]?.start &&
          moment(dateRanges?.default?.[0]?.start).isValid())) && (
        <>
          <Grid item xs={12}>
            <Typography variant="overline" sx={{ color: '#203A3E' }}>
              {disabled || reply
                ? 'Available date ranges:'
                : 'Select a range on the calendar'}
            </Typography>
            {!showInstructions && (
              <Tooltip
                open={open}
                onClose={handleClose}
                onOpen={handleOpen}
                title="Click for help center"
                arrow
                placement={'right'}
              >
                <IconButton
                  onClick={() => {
                    setShowInstructions(true);
                  }}
                >
                  <HelpCenter
                    sx={{
                      // color: theme => theme.palette.common.white,
                      fontSize: { xs: 12, sm: 18 },
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Grid>

          {[...dateRanges?.default]
            .sort((a, b) => moment(a.start).diff(b.start))
            .sort((a, b) => a.id - b.id)
            .map((dateRange, index) => (
              <Grid key={`date-range-item-${index}`} item xs={6}>
                <RangeItem {...dateRange} mode={'default'} />
              </Grid>
            ))}

          {!disabled &&
            !reply &&
            (!single ||
              (activeDateRange.mode === 'default' &&
                dateRanges.default.length === 0)) && (
              <Grid item xs={12}>
                <AddRangeButton />
              </Grid>
            )}
        </>
      )}

      {(disabled || reply) && (
        <>
          {dateRanges?.default?.length > 0 &&
            dateRanges?.default?.[0]?.start &&
            moment(dateRanges?.default?.[0]?.start).isValid() && (
              <>
                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="overline" sx={{ color: '#203A3E' }}>
                    {disabled || reply
                      ? 'Your selected dates within available ranges:'
                      : 'Select the date range for this event'}
                  </Typography>
                </Grid>
                {dateRanges.reply && dateRanges.reply.length > 0 ? (
                  <>
                    {[...dateRanges.reply]
                      .sort((a, b) => moment(a.start).diff(b.start))
                      .sort((a, b) => a.id - b.id)
                      .map((dateRange, index) => (
                        <Grid key={`date-range-item-${index}`} item xs={6}>
                          <RangeItem
                            {...dateRange}
                            disable={reply ? false : undefined}
                            mode={'reply'}
                          />
                        </Grid>
                      ))}
                  </>
                ) : (
                  <Grid key={`date-range-item-default`} item xs={6}>
                    <RangeItem
                      id={-1}
                      start={null}
                      end={null}
                      disable={reply ? false : undefined}
                      mode={'reply'}
                    />
                  </Grid>
                )}
                {dateRanges.reply &&
                  dateRanges.reply.length > 0 &&
                  !dateRanges.reply.find(
                    d => d.id === activeDateRange.index
                  ) && (
                    <Grid key={`date-range-item-default`} item xs={6}>
                      <RangeItem
                        id={activeDateRange.index || -1}
                        start={null}
                        end={null}
                        disable={reply ? false : undefined}
                        mode={'reply'}
                      />
                    </Grid>
                  )}
              </>
            )}
          {dateRanges.suggest && dateRanges.suggest.length > 0 ? (
            <>
              {dateRanges?.default?.length > 0 &&
                dateRanges?.default?.[0]?.start &&
                moment(dateRanges?.default?.[0]?.start).isValid() && (
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                )}
              <Grid item xs={12}>
                <Typography variant="overline" sx={{ color: '#203A3E' }}>
                  Your{' '}
                  {dateRanges?.default?.length > 0 &&
                    dateRanges?.default?.[0]?.start &&
                    moment(dateRanges?.default?.[0]?.start).isValid() &&
                    'additional'}{' '}
                  suggested ranges:
                </Typography>
                {!showInstructions &&
                  !(
                    dateRanges?.default?.length > 0 &&
                    dateRanges?.default?.[0]?.start &&
                    moment(dateRanges?.default?.[0]?.start).isValid()
                  ) && (
                    <Tooltip
                      open={open}
                      onClose={handleClose}
                      onOpen={handleOpen}
                      title="Click for help center"
                      arrow
                      placement={'right'}
                    >
                      <IconButton
                        onClick={() => {
                          setShowInstructions(true);
                        }}
                      >
                        <HelpCenter
                          sx={{
                            // color: theme => theme.palette.common.white,
                            fontSize: { xs: 12, sm: 18 },
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  )}
              </Grid>
              {dateRanges.suggest &&
                [...(dateRanges.suggest || [])]
                  .sort((a, b) => moment(a.start).diff(b.start))
                  .sort((a, b) => a.id - b.id)
                  .map((dateRange, index) => (
                    <Grid key={`date-range-item-${index}`} item xs={6}>
                      <RangeItem
                        {...dateRange}
                        disable={reply ? false : undefined}
                        mode={'suggest'}
                      />
                    </Grid>
                  ))}
            </>
          ) : (
            <div />
          )}
          {!disabled && (
            <Grid item xs={12}>
              <AddRangeButton reply={reply} />
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};
